import { render, staticRenderFns } from "./HotspotAnswer.vue?vue&type=template&id=1408cd8d&"
import script from "./HotspotAnswer.vue?vue&type=script&lang=js&"
export * from "./HotspotAnswer.vue?vue&type=script&lang=js&"
import style0 from "./HotspotAnswer.vue?vue&type=style&index=0&id=1408cd8d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports